// extracted by mini-css-extract-plugin
export var sm = "768";
export var md = "1024";
export var lg = "1280";
export var xl = "1600";
export var wrapper = "CircleBG-module--wrapper--Dpn-Y";
export var image = "CircleBG-module--image---b1GD";
export var left = "CircleBG-module--left--CGFW8";